import {
  BorderColorRounded,
  CloudDoneOutlined,
  MailOutline,
  NoteAddOutlined,
  Print,
  Visibility,
} from "@mui/icons-material";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Tooltip, Typography, Zoom } from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getConnectivityErrors } from "../../../../../actions/connectivityResponse";
import { openNewForm } from "../../../../../actions/formsState";
import CircularLoading from "../../../../commons/loadingData/circularLoading";
import { StyledAccidentDocumentsCards } from "../../../../styled/accident";
import NewsIconComponent from "./icons/NewsIconComponent";
const AccidentDocumentsCards = ({
  data,
  loading,
  handleOpenDetail,
  handleOpenSign,
  handleOpenNullifyForm,
  setOpenErroresConectividadDialog,
  handlePrintSpecificFpa,
}) => {
  const dispatch = useDispatch();
  const esPrestador = useSelector((state) => state.auth.roles?.PRESTADOR);
  const accident = useSelector((state) => state.accidentDashboard.accident);
  const documentation = useSelector(
    (state) => state.accidentDashboard.availableDocumentsToAdd,
  );

  const handleOpenNews = (document) => {
    dispatch(
      getConnectivityErrors(document.nroTransaccion, accident.mlCloudCoreArtId),
    ).then(() => {
      setOpenErroresConectividadDialog(document);
    });
  };

  return (
    <StyledAccidentDocumentsCards.Container>
      {loading ? (
        <CircularLoading />
      ) : data.length ? (
        data.map((document) => (
          <StyledAccidentDocumentsCards.Card
            key={document.nroFormulario}
            backgroundColor={
              document.aceptaIdr && !document.asociado ? "#f4f5df" : ""
            }>
            <StyledAccidentDocumentsCards.FormInfoContainer>
              <StyledAccidentDocumentsCards.FormDate variant="body2">
                {moment(document.fechaHoraFormulario).format("DD/MM/YYYY")}
              </StyledAccidentDocumentsCards.FormDate>
              <Typography
                variant="body2"
                color={
                  document.usuarioCreacion === document.usuarioModificacion &&
                    document.usuarioCreacion === "ProcesoPoint"
                    ? "error"
                    : ""
                }>
                {document.nombreFormulario}
              </Typography>
            </StyledAccidentDocumentsCards.FormInfoContainer>
            <div>
              <StyledAccidentDocumentsCards.RowContainer>
                {
                  {
                    Servicio: (
                      <Tooltip
                        title="Enviado por servicio"
                        TransitionComponent={Zoom}
                        arrow>
                        <CloudDoneOutlined />
                      </Tooltip>
                    ),
                    Correo: (
                      <Tooltip
                        title="Enviado por mail"
                        TransitionComponent={Zoom}
                        arrow>
                        <MailOutline />
                      </Tooltip>
                    ),
                  }[document.metodoEnvio]
                }
                <StyledAccidentDocumentsCards.RecivedByArt variant="body2">
                  {document.fechaRecibidoPorLaArt
                    ? moment(document.fechaRecibidoPorLaArt).format(
                      "DD/MM/YYYY",
                    )
                    : null}
                </StyledAccidentDocumentsCards.RecivedByArt>
              </StyledAccidentDocumentsCards.RowContainer>
              <Typography variant="body2">{document.estado}</Typography>
            </div>
            <NewsIconComponent
              document={document}
              openNews={handleOpenNews}
            />
            <StyledAccidentDocumentsCards.ActionsContainer>
              {esPrestador && (
                <>
                  {document.comportamiento == "Fpa" &&
                    <Tooltip
                      title={"Imprimir FPA"}
                      arrow
                    >
                      <StyledAccidentDocumentsCards.Button onClick={() => handlePrintSpecificFpa(document)}>
                        <Print />
                      </StyledAccidentDocumentsCards.Button>
                    </Tooltip>
                  }
                  {document.aceptaIdr && (
                    <Tooltip
                      title={
                        document.editable
                          ? "Asociar formulario"
                          : "Asociar formulario (Deshabilitado)"
                      }
                      arrow>
                      <StyledAccidentDocumentsCards.ButtonAsociarFormulario
                        disabled={!document.editable}>
                        <NoteAddOutlined
                          onClick={() => {
                            dispatch(
                              openNewForm(
                                "idr",
                                documentation.data.find(
                                  (f) => f.formulario === "Idr",
                                )?.nombre,
                                { nroFormularioFPA: document.nroFormulario },
                              ),
                            );
                          }}
                        />
                      </StyledAccidentDocumentsCards.ButtonAsociarFormulario>
                    </Tooltip>
                  )}
                  {document.aceptaFirmaTrabajador && (
                    <Tooltip
                      title={
                        document.editable
                          ? "Firma del trabajador"
                          : "Firma del trabajador (Deshabilitado)"
                      }
                      arrow
                    >
                      <StyledAccidentDocumentsCards.ButtonAsociarFormulario
                        disabled={!document.editable}>
                        <BorderColorRounded
                          onClick={() =>
                            accident.editable ? handleOpenSign(document) : null
                          }
                        />
                      </StyledAccidentDocumentsCards.ButtonAsociarFormulario>
                    </Tooltip>
                  )}
                </>
              )}
              {document.anulable && esPrestador && (
                <Tooltip
                  title={"Anular Formulario"}
                >
                  <StyledAccidentDocumentsCards.Button onClick={() => handleOpenNullifyForm(document.nroFormulario)} >
                    <CancelOutlinedIcon />
                  </StyledAccidentDocumentsCards.Button>
                </Tooltip>
              )}
              <Tooltip
                title={
                  document.permitirVisualizacion
                    ? "Ver documento"
                    : "Sin permiso para visualizar"
                }
                onClick={() =>
                  document.permitirVisualizacion
                    ? handleOpenDetail(document)
                    : null
                }>
                {document.permitirVisualizacion ? (
                  <StyledAccidentDocumentsCards.Button>
                    <Visibility />
                  </StyledAccidentDocumentsCards.Button>
                ) : (
                  <StyledAccidentDocumentsCards.DisableButton>
                    <Visibility />
                  </StyledAccidentDocumentsCards.DisableButton>
                )}
              </Tooltip>
            </StyledAccidentDocumentsCards.ActionsContainer>
          </StyledAccidentDocumentsCards.Card>
        ))
      ) : (
        <StyledAccidentDocumentsCards.EmptyState variant="body2">
          No hay documentos disponibles
        </StyledAccidentDocumentsCards.EmptyState>
      )}
    </StyledAccidentDocumentsCards.Container>
  );
};

export default AccidentDocumentsCards;
